import { z } from 'zod';

/**
 * Every language the platform speaks. Each code has a language pack in
 * `@hero/agent` (`languageRegistry`); the registry spec fails when the
 * two drift. Add a language here and in its pack together — see
 * `docs/ai/multi-language.md` § Add a language.
 */
export const LANGUAGE_CODES = ['ar', 'en', 'ur'] as const;

export const languageSchema = z.enum(LANGUAGE_CODES);
export type Language = z.infer<typeof languageSchema>;

/**
 * What set a thread's language, weakest first. A write only lands when
 * the new evidence ranks at or above the stored source — see
 * `decideLanguageChange` in `@hero/agent`.
 *
 * - `default`     — header / persona / line default at creation.
 * - `hint`        — a short message with a weak script signal ("Hello").
 * - `nationality` — guessed from the إقامة nationality on a wordless turn.
 * - `accent`      — learner Arabic (Pakistani / Indian speaker).
 * - `typed`       — a real sentence in that language.
 * - `voice`       — a confident STT language detection.
 * - `user_choice` — the language picker or "speak English"; pinned.
 */
export const languageSourceSchema = z.enum([
  'default',
  'hint',
  'nationality',
  'accent',
  'typed',
  'voice',
  'user_choice',
]);
export type LanguageSource = z.infer<typeof languageSourceSchema>;
